var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\xCE\\xD3\\xC8_1",
    "data-name": "\\u2014\\xCE\\xD3\\xC8_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.81 14.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:green;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "check_mark_TRF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.63.37A.94.94,0,0,0,15.84,0,1.69,1.69,0,0,0,15,.32l-.06,0-.1.06A33.51,33.51,0,0,0,9,5.51a28.67,28.67,0,0,0-3.78,5L5,10.17A12.7,12.7,0,0,0,1.7,6.78,1.31,1.31,0,0,0,1,6.6a1.14,1.14,0,0,0-.52.12,1,1,0,0,0-.42.45A1.25,1.25,0,0,0,.48,8.53a22.08,22.08,0,0,1,3.2,5c.08.16.14.3.2.4a1.83,1.83,0,0,0,1.52,1h.12A2,2,0,0,0,7,13.78a1.19,1.19,0,0,0,.08-.16l0,0C9.69,8.5,12.74,4.55,16,2.17l.06,0a2.5,2.5,0,0,0,.51-.48A1,1,0,0,0,16.63.37Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.619f74d242d1d58a418a948cd8f81f13.svg";
export { ForwardRef as ReactComponent };